import { gql } from 'graphql-tag'

/**
 * knowledgeHubLabelsQuery
 *
 * fetches Knowledge Hub labels for all locales
 */
export const queryKnowledgeHubLabelsCollection = ({locales, preview}, queryAllLocales) => {

    return gql`
    fragment knowledgeHubLabelsFragment on KnowledgeHubLabels {
        backLink
        articleTypeFilter
        topicFilter
        industryFilter
        productFilter
        sidebarTopics
        sidebarShare
        relatedArticles
        gatedContentDownloadButton
        loadMoreArticlesButton
        infoBlock
        highlightCard
        introduction
        impact
        watchTheVideo
        readTheStory
        summarize
    }

    query knowledgeHubLabelsCollectionQuery {
        ${queryAllLocales({ typeName: 'knowledgeHubLabelsCollection', fragment: 'knowledgeHubLabelsFragment', internalName: 'KnowledgeHubLabels'}, { locales, preview})}
    }
`
}
